import React from 'react'

/**
 * Ghost icon-only button. Wraps a child icon (typically `<Icon />` or a
 * unicode glyph). Always requires `aria-label`.
 */
export function IconButton({
  children,
  ariaLabel,
  type = 'button',
  disabled = false,
  className = '',
  ...rest
}) {
  if (process.env.NODE_ENV !== 'production' && !ariaLabel && !rest['aria-label']) {
    // eslint-disable-next-line no-console
    console.warn('<IconButton> requires `ariaLabel` (or `aria-label`).')
  }
  const classes = ['icon-button', className].filter(Boolean).join(' ')
  return (
    <button
      type={type}
      className={classes}
      aria-label={ariaLabel || rest['aria-label']}
      disabled={disabled}
      {...rest}
    >
      {children}
    </button>
  )
}
